export default __webpack_public_path__ + "static/media/green_chimicals.9bdb7a64.svg";